import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import OrdersComponent from '../components/OrdersComponent';
import HeaderComponent from '../components/HeaderComponent';

class OrdersPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <OrdersComponent location={this.props.location}/>
            </div>
        );
    }
}

export default OrdersPage;